import React from 'react'

type Props = {
    chat    : {
        id      : ID
        type    : string
        title   : string
    }

    isOpen  : boolean
}

type State = {
    over    : boolean
}

export default class TaskTrayChat extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            over: false
        }
    }

    onMouseEnter = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        this.setState({
            over: true
        })
    }

    onMouseLeave = (e: React.MouseEvent) => {
        this.setState({
            over: false
        })
    }

    onCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        gd.taskTray.removeChat(this.props.chat.id)
    }

    onChatClick = () => {
        gd.bus.triggerEvent('chat:view',this.props.chat.id)

        switch (this.props.chat.type) {
            case 'discussion'   : gd.goTo('discussion/'+this.props.chat.id); break
            default             : gd.goTo('c/'+this.props.chat.id); break
        }
    }

    render() {
        const classes = Classes('chat', {
            open: this.props.isOpen
        })

        return (
            <div className={classes} onClick={this.onChatClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className="name">{this.props.chat.title}</div>
                {this.state.over &&
                    <div className="i5-delete" onClick={this.onCloseClick}/>}
            </div>
        )
    }
}